import request from '@/utils/request/next-request';

/**
 * 使用nextRequest的请求
 */

// 获取Kconf配置
export function getKconfContent(params: {
  key: string;
  name: string;
  folder: string;
}) {
  return request({
    url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/get-kconf-content`,
    method: 'get',
    data: params,
  });
}
